import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6 mb-3" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "col-md-4 mb-3" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "col-md-2 mb-3" }
const _hoisted_9 = { class: "form-check mt-3 mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-md-12 mb-md-25" }
const _hoisted_12 = {
  class: "accordion",
  id: "basicAccordion"
}
const _hoisted_13 = { class: "accordion-item mb-0 bord1" }
const _hoisted_14 = {
  id: "basicCollapseOne",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#basicAccordion"
}
const _hoisted_15 = { class: "accordion-body" }
const _hoisted_16 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_17 = {
  class: "tab-pane fade show active p-10",
  id: "home-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "border border-primary mb-10" }
const _hoisted_20 = {
  class: "row d-flex align-items-center justify-content-between fw-bold py-2",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_21 = { class: "col-md-5" }
const _hoisted_22 = { class: "d-flex float-end" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "col-md-5 mb-2" }
const _hoisted_25 = { class: "" }
const _hoisted_26 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_27 = { class: "col-md-5 mb-2" }
const _hoisted_28 = { class: "" }
const _hoisted_29 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_30 = { class: "col-md-2 mb-2" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "col-md-12 mt-3" }
const _hoisted_33 = { class: "d-flex align-items-center" }
const _hoisted_34 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.addModeleSignataire,
        "validation-schema": _ctx.modeleSignataireSchema,
        "keep-values": _ctx.valuess
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[2] || (_cache[2] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Désignation "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "designation",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer la désignation"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "designation",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Type Document"),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "typeDocument" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.typeDocumentOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label",
                      placeholder: "Sélectionner le type de document",
                      multiple: false
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "typeDocument",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("div", _hoisted_9, [
                _cache[4] || (_cache[4] = _createElementVNode("label", {
                  for: "estActif",
                  class: "form-check-label fw-medium position-relative top-1"
                }, " Est Actif ? ", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "estActif",
                  name: "estActif",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.estActif) = $event)),
                  value: _ctx.estActif,
                  type: "checkbox",
                  class: "form-check-input shadow-none"
                }, null, 8, _hoisted_10), [
                  [_vModelCheckbox, _ctx.estActif]
                ]),
                _createVNode(_component_ErrorMessage, {
                  name: "estActif",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[11] || (_cache[11] = _createElementVNode("h2", {
                    class: "accordion-header",
                    id: "headingOne"
                  }, [
                    _createElementVNode("button", {
                      class: "accordion-button collapsed",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": "#basicCollapseOne",
                      "aria-expanded": "false",
                      "aria-controls": "basicCollapseOne"
                    }, " Personnels et fonctions ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-md-7" }, [
                                  _createElementVNode("h3", { class: "fs-4 text-white" }, " Personnels et fonctions ")
                                ], -1)),
                                _createElementVNode("div", _hoisted_21, [
                                  _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("button", {
                                      class: _normalizeClass(["default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success", { 'cursor-not-allowed': _ctx.isDisable }]),
                                      type: "button",
                                      disabled: _ctx.isDisable,
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addRowPersonnelFonction()))
                                    }, _cache[6] || (_cache[6] = [
                                      _createElementVNode("i", { class: "fa fa-plus-circle position-relative ms-5 fs-12" }, null, -1),
                                      _createTextVNode(" Ajouter un personnel ")
                                    ]), 10, _hoisted_23),
                                    _createVNode(_component_router_link, { to: "/liste-mouvements" })
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "row d-flex align-items-center justify-content-between mt-10" }, [
                                  _createElementVNode("div", { class: "col-md-5" }, [
                                    _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                      _createTextVNode(" Signataire "),
                                      _createElementVNode("span", { class: "text-danger" }, "*")
                                    ])
                                  ]),
                                  _createElementVNode("div", { class: "col-md-5" }, [
                                    _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                      _createTextVNode(" Fonction "),
                                      _createElementVNode("span", { class: "text-danger" }, "*")
                                    ])
                                  ]),
                                  _createElementVNode("div", { class: "col-md-2" }, [
                                    _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Action ")
                                  ])
                                ], -1)),
                                _cache[10] || (_cache[10] = _createElementVNode("hr", { class: "mt-0" }, null, -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.personnelFonctions, (personnelFonction, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "row",
                                    key: index
                                  }, [
                                    _createElementVNode("div", _hoisted_24, [
                                      _createElementVNode("div", _hoisted_25, [
                                        _createVNode(_component_Multiselect, {
                                          options: _ctx.personnelOptions,
                                          searchable: true,
                                          "track-by": "label",
                                          label: "label",
                                          modelValue: personnelFonction.personnel,
                                          "onUpdate:modelValue": ($event: any) => ((personnelFonction.personnel) = $event),
                                          placeholder: "Sélectionner le personnel"
                                        }, null, 8, ["options", "modelValue", "onUpdate:modelValue"]),
                                        (_ctx.valideteRowPersonnel(personnelFonction.personnel))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, " Le personnel est obligatoire. "))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_27, [
                                      _createElementVNode("div", _hoisted_28, [
                                        _createVNode(_component_Multiselect, {
                                          options: _ctx.fonctionOptions,
                                          searchable: true,
                                          "track-by": "label",
                                          label: "label",
                                          modelValue: personnelFonction.fonction,
                                          "onUpdate:modelValue": ($event: any) => ((personnelFonction.fonction) = $event),
                                          placeholder: "Sélectionner la Fonction"
                                        }, null, 8, ["options", "modelValue", "onUpdate:modelValue"]),
                                        (_ctx.valideteRowPersonnel(personnelFonction.fonction))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, " La fonction est obligatoire. "))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_30, [
                                      _createElementVNode("button", {
                                        class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                                        type: "button",
                                        onClick: ($event: any) => (_ctx.removeRowPersonnelFonction(index))
                                      }, _cache[8] || (_cache[8] = [
                                        _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                                      ]), 8, _hoisted_31)
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-success me-3", { 'cursor-not-allowed': _ctx.isDisable }]),
                  type: "submit",
                  disabled: _ctx.isDisable
                }, " Ajouter un modèle signataire ", 10, _hoisted_34),
                _createVNode(_component_router_link, {
                  to: "/liste-produits",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "keep-values"])
    ])
  ]))
}